

export const translations = {
	classicSeries: {
		h1_title: {
			en: "CLASSIC SERIES",
			fr: "SÉRIE CLASSIC",
		},
		h2_choose_your_model: {
			en: "Choose your model",
			fr: "Choisissez votre modèle",
		},
		classic_2_2_list: {
			en: [
				"4-wheel disc brakes",
				"9-inch touch screen",
				"Led lights",
				"Seatbelts",
				"48V 110Ah lithium battery",
				"Electric parking brake",
				"Rear view camera",
				"14 inch wheel",
				"Integrated charger",
				"Trunk",
				"AC Controller 400A",
				"Sound system with 2 speakers",
				"Turn signal, stop light",
				"6.3 kw Motor with EM brake",
			],
			fr: [
				"Freins à disque 4 roues",
				"Écran tactile 9 pouces",
				"Lumières LED",
				"Ceintures de sécurité",
				"Batterie lithium 48V 110Ah",
				"Frein de stationnement électrique",
				"Caméra de recul",
				"Roue de 14 pouces",
				"Chargeur intégré",
				"Coffre arrière",
				"Contrôleur AC 400A",
				"Système audio avec 2 haut-parleurs",
				"Clignotant, feu d'arrêt",
				"Moteur 6.3 kw avec frein EM",
			],
		},
		classic_thor_list: {
			en: [
				"4-wheel disc brakes",
				"9-inch touch screen",
				"Led lights",
				"Seatbelts",
				"48V 110Ah lithium battery",
				"Electric parking brake",
				"Rear view camera",
				"14 inch wheel",
				"Integrated charger",
				"Aluminum cargo box",
				"AC Controller 400A",
				"Turn signal, stop light",
				"4 kw Motor"
			],
			fr: [
				"Freins à disque 4 roues",
				"Écran tactile 9 pouces",
				"Lumières LED",
				"Ceintures de sécurité",
				"Batterie lithium 48V 110Ah",
				"Frein de stationnement électrique",
				"Caméra de recul",
				"Roue de 14 pouces",
				"Chargeur intégré",
				"Coffre de chargement en aluminium",
				"Contrôleur AC 400A",
				"Clignotant, feu d'arrêt",
				"Moteur 4 kw"
			],
		},
		h3_colorPicker: {
			en: "Color Options",
			fr: "Options de couleur",
		},
		p_colorPicker: {
			en: "*Please note that due to variations between screens, actual colors may vary. Check with your dealer for actual colors.",
			fr: "*Veuillez noter qu'en raison des variations entre les écrans, les couleurs réelles peuvent varier. Vérifiez auprès de votre revendeur les couleurs réelles.",
		},
	
		h2_span_discover: {
			en: "EXPLORE CLASSIC SERIES",
			fr: "EXPLOREZ LA SÉRIE CLASSIC",
		},
		h2_discover: {
			en: "Discover the comfort and innovation",
			fr: "Découvrez le confort et l'innovation",
		},
		h2_discoverNext: {
			en: "of our carts.",
			fr: "de nos voiturettes.",
		},
		p_discover: {
			en: "The Classic Series offers a range of high-performance electric vehicles designed for both urban and off-road adventures. With cutting-edge technology and sleek designs, the Luxor Series is perfect for those who seek both style and functionality.",
			fr: "La série Classic propose une gamme de véhicules électriques de hautes performances conçus pour les aventures urbaines et tout-terrain. Avec une technologie de pointe et des designs élégants, la série Classic est parfaite pour ceux qui recherchent à la fois style et fonctionnalité.",
		},
		t_cup_holder: {
			en: "CUP HOLDER",
			fr: "PORTE-GOBELET",
		},
		p_cup_holder: {
			en: "A good round of golf or a leisurely ride demands refreshment. Our built-in cupholder not only ensures your drink remains steady but also serves as a nifty spot for small essentials like USB cords. Whether it's a rejuvenating water bottle or a relaxing beer, it stays secure and within arm's reach.",
			fr: "Un bon parcours de golf ou une promenade tranquille nécessitent une boisson. Notre porte-gobelet intégré garantit non seulement que votre boisson reste stable, mais sert également de coin pratique pour de petites choses essentielles comme des cordons USB. Que ce soit une bouteille d'eau revitalisante ou une bière relaxante, elle reste sécurisée et à portée de main.",
		},
		t_storage: {
			en: "STORAGE COMPARTMENT",
			fr: "COMPARTIMENT DE RANGEMENT",
		},
		p_storage: {
			en: "Our cart's thoughtfully designed storage compartment keeps your essentials organized. Whether you're off on a summer camping trip or traversing cross-country, there's ample space to stow away your gear. Say goodbye to clutter and hello to organized convenience.",
			fr: "Le compartiment de rangement de notre voiturette est conçu pour garder vos essentiels organisés. Que vous partiez en camping d'été ou que vous traversiez le pays, il y a suffisamment d'espace pour ranger votre équipement. Dites adieu au désordre et bonjour à la commodité organisée.",
		},
		t_battery: {
			en: "LITHIUM-ION BATTERY",
			fr: "BATTERIE LITHIUM-ION",
		},
		p_battery: {
			en: "Powering our carts is the superior lithium-ion battery, commonly found in high-end electronics and vehicles. Chosen for its consistent high performance and durability, it ensures our carts stand up to rigorous use. It's not just a battery; it's a promise of unmatched efficiency.",
			fr: "Alimentant nos voiturettes, la batterie lithium-ion supérieure, couramment utilisée dans les appareils électroniques et véhicules haut de gamme. Choisie pour sa performance élevée constante et sa durabilité, elle garantit que nos voiturettes résistent à une utilisation rigoureuse. Ce n'est pas juste une batterie ; c'est une promesse d'efficacité inégalée.",
		},
		t_tire: {
			en: "TIRE",
			fr: "PNEU",
		},
		p_tire: {
			en: "Navigate the greens effortlessly with our specially-designed tires. Fitted with 14-inch alloy rims with color-matched inserts, they're not just about good looks. The flat tread minimizes course damage, while the siping detail promotes water dispersion and improves traction. Experience a seamless ride, regardless of the terrain.",
			fr: "Naviguez sur les greens sans effort avec nos pneus spécialement conçus. Équipés de jantes en alliage de 14 pouces avec des inserts assortis, ils ne sont pas seulement esthétiques. La bande de roulement plate minimise les dommages au parcours, tandis que le détail de la sculpture favorise la dispersion de l'eau et améliore l'adhérence. Profitez d'une conduite fluide, quel que soit le terrain.",
		},
		t_screen: {
			en: "TOUCHSCREENS",
			fr: "ÉCRANS TACTILES",
		},
		p_screen: {
			en: "Experience unmatched ease with our 9-inch touchscreen interface. From streaming your favorite tunes to navigating radio stations and checking your speed, this central console combines features such as Bluetooth connectivity, a back-up camera, and smartphone app integration. Elevate your ride and maintain effortless control with everything just a fingertip away.",
			fr: "Découvrez une facilité inégalée avec notre interface à écran tactile de 9 pouces. De la diffusion de vos morceaux préférés à la navigation dans les stations de radio et à la vérification de votre vitesse, cette console centrale combine des fonctionnalités telles que la connectivité Bluetooth, une caméra de recul et l'intégration d'applications pour smartphone. Élevez votre conduite et maintenez un contrôle sans effort avec tout à portée de main.",
		},
		t_golfBalls: {
			en: "GOLF BALL HOLDER",
			fr: "PORTE-BALLES DE GOLF",
		},
		p_golfBalls: {
			en: "Stay ever-ready for that impromptu golf session. The it comes equipped with a dedicated golf ball holder, designed to securely house up to four golf balls. It's all about ensuring convenience and accessibility when you need it most.",
			fr: "Restez toujours prêt pour cette session de golf improvisée. Il est équipé d'un porte-balles de golf dédié, conçu pour accueillir en toute sécurité jusqu'à quatre balles de golf. Il s'agit de garantir commodité et accessibilité lorsque vous en avez le plus besoin.",
		},
		t_tailLight: {
			en: "TAIL LIGHTS",
			fr: "FEUX ARRIÈRE",
		},
		p_tailLight: {
			en: "Illuminate your path and make your presence felt, day or night. Our team, driven by a zeal to perfect night-time driving experiences, presents top-notch LED tail lights for the Mini-Thor. Customized for your vehicle, these lights not only fit within your budget but also ensure you stand out, even in the dark.",
			fr: "Illuminez votre chemin et faites-vous remarquer, de jour comme de nuit. Notre équipe, animée par le désir de perfectionner les expériences de conduite nocturne, propose des feux arrière LED de premier ordre pour le Mini-Thor. Personnalisés pour votre véhicule, ces feux s'adaptent à votre budget tout en vous assurant de vous démarquer, même dans l'obscurité.",
		},
		t_cargoBox: {
			en: "CARGO BOX",
			fr: "COFFRE DE CHARGEMENT",
		},
		p_cargoBox: {
			en: "When it's about heavy-duty hauling in commercial or recreational settings, the Mini-Thor doesn't disappoint. Fitted with a robust thermoplastic cargo box at its rear, it provides ample space to transport tools, equipment, or personal belongings. Whether you're headed for hunting, farming, or a beach escapade, this cargo box promises durability and longevity.",
			fr: "Lorsqu'il s'agit de transport intensif dans des environnements commerciaux ou récréatifs, le Mini-Thor ne déçoit pas. Équipé d'un robuste coffre de chargement en thermoplastique à l'arrière, il offre un espace suffisant pour transporter des outils, de l'équipement ou des effets personnels. Que vous vous dirigiez vers la chasse, l'agriculture ou une escapade à la plage, ce coffre promet durabilité et longévité.",
		},
		h2_spec_title: {
			en: "SPECIFICATIONS",
			fr: "SPÉCIFICATIONS",
		},
		h3_spec_dimensions: {
			en: "DIMENSIONS",
			fr: "DIMENSIONS",
		},
		h3_spec_power: {
			en: "POWER",
			fr: "PUISSANCE",
		},
		h3_spec_features: {
			en: "FEATURES",
			fr: "FONCTIONNALITÉS",
		},
		h3_spec_additional_features: {
			en: "ADDITIONAL FEATURES",
			fr: "FONCTIONNALITÉS SUPPLÉMENTAIRES",
		},
		h3_spec_body: {
			en: "BODY & CHASSIS",
			fr: "CARROSSERIE & CHÂSSIS",
		},
		list_spec_power: {
			en: [
				"48 V 110 Ah Lithium battery",
				"6.3 kW motor with EM brake",
				"400 A, AC controller",
				"Integrated 25 A charger",
				"Maximum speed ≥ 30 km/h (19 mph)"
			],
			fr: [
				"Batterie lithium 48 V 110 Ah",
				"Moteur 6.3 kW avec frein EM",
				"Contrôleur 400 A, AC",
				"Chargeur intégré 25 A",
				"Maximum speed ≥ 30 km/h (19 mph)"
			],
		},
		list_spec_power_thor: {
			en: [
				"48 V 110 Ah Lithium battery",
				"4 kW motor",
				"400 A, AC controller",
				"Integrated 25 A charger",
				"Maximum speed ≥ 30 km/h (19 mph)"
			],
			fr: [
				"Batterie lithium 48 V 110 Ah",
				"Moteur 4 kW",
				"Contrôleur 400 A, AC",
				"Chargeur intégré 25 A",
				"Vitesse maximale ≥ 30 km/h (19 mph)"
			],
		},
		list_spec_features: {
			en: [
				"9-inch touchscreen with Speedometer display ,back-up camera ,Stereo system ,Bluetooth connection ……",
				"Luxury 2 Tone Seats",
				"Decorative Strip",
				"Colored Decorative Wheel Trim",
				"Dashboard with color-matching cupholder insert",
				"Luxury Steering Wheel",
				"Extended roof and flip flop rear seat kits",
				"Plastic rear seat kit with trunk & cup holders",
				"Rearview Mirror",
				"Horn",
				"USB Charging Ports"
			],
			fr: [
				"Écran tactile de 9 pouces avec affichage du compteur de vitesse, caméra de recul, système stéréo, connexion Bluetooth ……",
				"Sièges de luxe 2 tons",
				"Bandes décoratives",
				"Jante décorative colorée",
				"Tableau de bord avec insert de porte-gobelet assorti",
				"Volant de luxe",
				"Toit prolongé et kits de siège arrière repliable",
				"Kits de siège arrière en plastique avec coffre et porte-gobelets",
				"Rétroviseur",
				"Klaxon",
				"Ports de charge USB"
			],
		},
		list_spec_features_classicThor: {
			en: [
				"Double A-arm coil-over suspension for a smooth quality ride feel",
				"Two tone seat",
				"Dashboard with color-matching cupholder",
				"Luxury Steering Wheel",
				"Dashboard with color-matching cupholder insert",
				"Luxury Steering Wheel",
				"9-inch touchscreen with Speedometer display, back-up camera, Stereo system, Bluetooth connection, etc.",
				"Side Mirrors",
				"Horn",
				"USB Charging Ports",
				"Aluminum Cargo Box"
			],
			fr: [
				"Suspension à double bras en A pour une conduite de qualité en douceur",
				"Siège bicolore",
				"Tableau de bord avec porte-gobelet assorti",
				"Volant de luxe",
				"Tableau de bord avec insert de porte-gobelet assorti",
				"Volant de luxe",
				"Écran tactile de 9 pouces avec affichage du compteur de vitesse, caméra de recul, système stéréo, connexion Bluetooth, etc.",
				"Rétroviseurs latéraux",
				"Klaxon",
				"Ports de charge USB",
				"Coffre de chargement en aluminium"
			],
		},
		list_spec_additional_features: {
			en: [
				"Acid Dipped, Powder Coated Steel Chassis(Hot-Galvanized chassis optional) for a longer lifetime!",
				"25A Onboard waterproof charger, preprogrammed to the brands lithium batteries!",
				"Clear foldable windshield",
				"Optional Golf bag holder kits",
				"Impact-resistant injection mold bodies",
				"Independent suspension with four arms",
				"Assembled at factory in CANADA for proper quality control."
			],
			fr: [
				"Châssis en acier trempé, revêtu de poudre (châssis galvanisé à chaud en option) pour une durée de vie plus longue du chariot!",
				"Chargeur étanche de 25A, préprogrammé pour les batteries lithium de la marque!",
				"Pare-brise pliable transparent",
				"Kits de porte-bagages de golf en option",
				"Carrosseries en injection résistantes aux chocs",
				"Suspension indépendante à quatre bras",
				"Assemblé en usine au CANADA pour un contrôle de qualité approprié."
			],
		},
		list_spec_body: {
			en: [
				"TPO injection moulding front and rear body"
			],
			fr: [
				"Carrosserie avant et arrière en moulage par injection TPO"
			],
		},
		h2_shrink_touchscreen: {
			en: "9” TOUCHSCREEN",
			fr: "ÉCRAN TACTILE 9”",
		},
		p_shrink_touchscreen: {
			en: "",
			fr: "",
		},
		h2_shrink_usbPorts: {
			en: "2 USB CONNECTIONS",
			fr: "2 CONNEXIONS USB",
		},
		p_shrink_usbPorts: {
			en: "",
			fr: "",
		},
		h2_shrink_soundSystem: {
			en: "STEREO SYSTEM",
			fr: "SYSTÈME STÉRÉO",
		},
		p_shrink_soundSystem: {
			en: "",
			fr: "",
		},
		h2_shrink_handles: {
			en: "CEILING HANDLE",
			fr: "POIGNÉE DE PLAFOND",
		},
		p_shrink_handles: {
			en: "",
			fr: "",
		},
		h2_shrink_safetyBelts: {
			en: "SAFETY BELTS",
			fr: "CEINTURES DE SÉCURITÉ",
		},
		p_shrink_safetyBelts: {
			en: "",
			fr: "",
		},
		h2_shrink_cupHolders: {
			en: "CUP HOLDERS",
			fr: "PORTE-GOBELETS",
		},
		p_shrink_cupHolders: {
			en: "",
			fr: "",
		},
		h2_shrink_golfCompartment: {
			en: "GOLF BALL HOLDER",
			fr: "PORTE-BALLES DE GOLF",
		},	
		p_shrink_golfCompartment: {
			en: "",
			fr: "",
		},
		h2_shrink_pedals: {
			en: "Accelerator / Brake Pedal",
			fr: "PÉDALE D'ACCÉLÉRATEUR / DE FREIN",
		},	
		p_shrink_pedals: {
			en: "",
			fr: "",
		},
		h2_shrink_golfBags: {
			en: "OPTIONAL GOLF BAG HOLDER",	
			fr: "PORTE-BAGAGES DE GOLF OPTIONNEL",
		},
		p_shrink_golfBags: {
			en: "",
			fr: "",
		},
		h2_shrink_rearAxle: {
			en: "REAR AXLE",
			fr: "ESSIEU ARRIÈRE",
		},
		p_shrink_rearAxle: {
			en: "",
			fr: "",
		},
		h2_shrink_lights: {
			en: "LIGHTS",
			fr: "LUMIÈRES",
	
		},
		p_shrink_lights: {
			en: "",
			fr: "",
		},
		h2_cupHolder2: {
			en: "CUP HOLDER",
			fr: "PORTE-GOBELET",
		},
		p_shrink_cupHolder2: {
			en: "",
			fr: "",
		},
		h2_shrink_TailLights: {
			en: "TAIL LIGHTS",
			fr: "FEUX ARRIÈRE",
		},
		p_shrink_TailLights: {
			en: "",
			fr: "",
		},

	},
} as const;

type TranslationKeys = typeof translations.classicSeries.h1_title;
export type Language = keyof TranslationKeys;
